import { createActionType, createAction, createApiCallAction } from './shared/helpers/redux';

const prefix = 'App';
export const ActionTypes = {
    loadUser: createActionType('loadUser')(prefix),
    loadUserCompleted: createActionType('loadUserCompleted')(prefix),
    setUserId: createActionType('setUserId')(prefix),
    confirmApplications: createActionType('confirmApplications')(prefix),
    denyApplications: createActionType('denyApplications')(prefix),
    sendEvent: createActionType('sendEvent')(prefix),
    sendAdvicesClickedEvent: createActionType('sendAdvicesClickedEvent')(prefix),
    sendAddApplicationClickedEvent: createActionType('sendAddApplicationClickedEvent')(prefix),
    sendAddApplicationContinueBtnEvent: createActionType('sendAddApplicationContinueBtnEvent')(prefix),
    sendCreatorClickedEvent: createActionType('sendCreatorClickedEvent')(prefix),
    sendEarningsClickedEvent: createActionType('sendEarningsClickedEvent')(prefix),
    sendPracujClickedEvent: createActionType('sendPracujClickedEvent')(prefix),
    sendTheProtocolClickedEvent: createActionType('sendTheProtocolClickedEvent')(prefix),
};

export const setUserId = createAction(ActionTypes.setUserId);
export const loadUser = createApiCallAction(ActionTypes.loadUser);
export const loadUserCompleted = createAction(ActionTypes.loadUserCompleted);
export const confirmApplications = (applicationIds) => createApiCallAction(ActionTypes.confirmApplications)({ payload: { applicationIds } });
export const denyApplications = (applicationIds) => createApiCallAction(ActionTypes.denyApplications)({ payload: { applicationIds } });
export const sendEvent = (name, data) => createAction(ActionTypes.sendEvent)({ payload: { name, data } });
export const sendAdvicesClickedEvent = () => createAction(ActionTypes.sendAdvicesClickedEvent)();
export const sendAddApplicationClickedEvent = () => createAction(ActionTypes.sendAddApplicationClickedEvent)();
export const sendAddApplicationContinueBtnEvent = (data) => createAction(ActionTypes.sendAddApplicationContinueBtnEvent)({ payload: { data } });
export const sendCreatorClickedEvent = () => createAction(ActionTypes.sendCreatorClickedEvent)();
export const sendEarningsClickedEvent = () => createAction(ActionTypes.sendEarningsClickedEvent)();
export const sendPracujClickedEvent = () => createAction(ActionTypes.sendPracujClickedEvent)();
export const sendTheProtocolClickedEvent = () => createAction(ActionTypes.sendTheProtocolClickedEvent)();